export default __webpack_public_path__ + "static/media/logo-importadores-en.82122071.png";